// extracted by mini-css-extract-plugin
module.exports = {"userInitials":"_1bQpkOQ0CBRJWMcEIg4JpF","small":"_8Cj3AWg_LYcsyq9ePttMu","container":"_1a2yuFFx1T3BNZ51su9HVv","badge":"_1NBaHezVP0dL4YY-0aXHRv"};